import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { ChevronLeft, ChevronRight, RefreshCw, Printer, Calendar } from 'lucide-react';

export default function DateLocationBar({
  locations,
  locationId,
  setLocationId,
  date,
  setDate,
  goToday,
  shiftDay,
  refresh,
  loading,
}) {
  return (
    <div
      className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between bg-white border-2 border-gray-300 rounded-2xl px-3 py-2 print:hidden"
      data-testid="dashboard-date-location-bar"
    >
      <div className="flex items-center gap-2">
        <Calendar className="w-4 h-4 text-gray-700" />
        <Select value={locationId || ''} onValueChange={setLocationId}>
          <SelectTrigger className="w-[240px] h-9 border-2 border-gray-300 font-semibold" data-testid="dashboard-location-select">
            <SelectValue placeholder="Select location" />
          </SelectTrigger>
          <SelectContent>
            {locations.map((l) => (
              <SelectItem key={l.id} value={l.id}>
                {l.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex flex-wrap items-center gap-1.5">
        <Button
          variant="outline"
          size="sm"
          className="h-9 px-2 border-2 border-gray-400 hover:bg-gray-100 hover:border-gray-700"
          onClick={() => shiftDay(-1)}
          data-testid="dashboard-prev-day-btn"
          aria-label="Previous day"
        >
          <ChevronLeft className="w-4 h-4 text-gray-800" strokeWidth={2.5} />
        </Button>
        <Input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          className="w-[160px] h-9 border-2 border-gray-300 font-semibold"
          data-testid="dashboard-date-input"
        />
        <Button
          variant="outline"
          size="sm"
          className="h-9 px-2 border-2 border-gray-400 hover:bg-gray-100 hover:border-gray-700"
          onClick={() => shiftDay(1)}
          data-testid="dashboard-next-day-btn"
          aria-label="Next day"
        >
          <ChevronRight className="w-4 h-4 text-gray-800" strokeWidth={2.5} />
        </Button>
        <Button
          variant="default"
          size="sm"
          className="h-9"
          onClick={goToday}
          data-testid="dashboard-today-btn"
        >
          Today
        </Button>
        <div className="w-px h-5 bg-gray-400 mx-1" />
        <Button
          variant="outline"
          size="sm"
          className="h-9 px-2 border-2 border-gray-400 hover:bg-gray-100 hover:border-gray-700"
          onClick={refresh}
          disabled={loading}
          data-testid="dashboard-refresh-btn"
          aria-label="Refresh schedule"
        >
          <RefreshCw className={`w-4 h-4 text-gray-800 ${loading ? 'animate-spin' : ''}`} strokeWidth={2.5} />
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="h-9 px-2 border-2 border-gray-400 hover:bg-gray-100 hover:border-gray-700"
          onClick={() => window.print()}
          data-testid="dashboard-print-btn"
          aria-label="Print schedule"
        >
          <Printer className="w-4 h-4 text-gray-800" strokeWidth={2.5} />
        </Button>
      </div>
    </div>
  );
}
